import React, { useCallback, useEffect, useState } from 'react';
import { AppNoInfo } from '@/layout/AppComponents';
import styled from 'styled-components';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { axiosPath } from '../../../../../../routing/helpers/router';
import Translator from '../../../../../components/helpers/Translator';
import * as currentPageAction from '../../../../../../store/actions/currentPageAction';
import colors from '../../../../../../constants/colors';
import errorHandler from '@/layout/components/error/ErrorHandler';
import useIsMounted from '../../../../../components/hooks/useIsMounted';

export default function GGCLSanctionTab(props) {
  const { obligationID } = props;
  const { moduleBridgeHex } = useParams();
  const isMounted = useIsMounted();
  const dispatch = useDispatch();
  const sanction = useSelector(
    (s) => s.currentPage?.sanctionTabs?.[obligationID]
  );
  const [edition, setEdition] = useState();
  const [remove, setRemove] = useState();
  const [isLoading, setIsLoading] = useState(false);

  // > LOAD SANCTION TAB
  const loadSanctionTab = useCallback(async () => {
    axios
      .post(
        axiosPath(
          "api_r_user_module_globalLegalCompliance_evaluation_tab_sanction"
        ),
        {
          obligationID,
          moduleBridgeHex,
        }
      )
      .then((r) => {
        if (isMounted.current) {
          dispatch(
            currentPageAction.change("sanctionTabs", {
              [obligationID]: r.data,
            })
          );
        }
      })
      .catch((e) => dispatch(errorHandler(e)));
  }, [obligationID, moduleBridgeHex]);

  useEffect(() => {
    if (!sanction) {
      loadSanctionTab();
    }
  }, []);
  // < LOAD SANCTION TAB

  if (!sanction) return <AppNoInfo minHeight={300} />;

  return (
    <Container>
      <SanctionContainer>
        <h3>
          <Translator file="user" name="user.obligations.location.penalty" />
        </h3>
        <div
          dangerouslySetInnerHTML={{ __html: sanction?.sanction }}
          style={{ height: '200px', overflowY: 'scroll' }}
        />
      </SanctionContainer>
    </Container>
  );
}

const Container = styled.div`
  height: 235px;
`;

const SanctionContainer = styled.div`
  border: 1px solid ${colors.grey300};
  padding: 4px;
`;
